export default "__VITE_ASSET__qgJHVrNy__";